import { SpinnerState, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
	root: {
		height: '100%',
		flex: '1 1 0',
	},
	largeSpinner: {
		height: '56px',
		width: '56px',
		['--fui-Spinner--strokeWidth']: '5px',
	},
	hugeSpinner: {
		height: '80px',
		width: '80px',
		['--fui-Spinner--strokeWidth']: '7px',
	},
	label: {
		textAlign: 'center',
	},
	hugeLabel: {
		lineHeight: tokens.lineHeightHero800,
	},
});

export const useCustomSpinnerStyles = (state: SpinnerState): SpinnerState => {
	const { root, largeSpinner, hugeSpinner, label, hugeLabel } = useStyles();

	state.root.className = mergeClasses(state.root.className, root);
	state.spinner.className = mergeClasses(state.spinner.className, state.size === 'large' && largeSpinner, state.size === 'huge' && hugeSpinner);

	if (state.label) {
		state.label.className = mergeClasses(state.label.className, label, state.size === 'huge' && hugeLabel);
	}

	return state;
};
